<template>
    <div class="rate-box">
        <div>
            <el-form inline>
                <el-form-item label="当日利率：" style="padding-top: 20px">
                    <el-input placeholder="当日利率" clearable v-model="award.todayRate" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="代币价格：" style="padding-top: 20px">
                    <el-input placeholder="代币价格" clearable v-model="award.coinPrice" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="所得币价格：" style="padding-top: 20px">
                    <el-input placeholder="所得币价格" clearable v-model="award.miningCoinPrice"
                              style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="奖励币种：" style="padding-top: 20px">
                    <el-input placeholder="奖励币种" clearable v-model="award.miningCoin" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item label="挖矿币种：" style="padding-top: 20px">
                    <el-autocomplete class="inline-input"
                                     v-model="award.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入挖矿币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item style="padding-top: 20px">
                    <el-button type="primary" @click="revenueCalculation">挖矿宝收益计算</el-button>
                    <el-upload style="display: inline-block;margin-left: 10px" ref="upload" action=""
                               :auto-upload="false" :show-file-list="false" accept="xlsx,xls,csv"
                               :on-change="onFileChange">
                        <el-button slot="trigger" icon="el-icon-upload" type="primary">导入文件</el-button>
                    </el-upload>
                    <!--<el-button type="primary" @click="incomeDistribution">挖矿宝收益发放</el-button>-->
                </el-form-item>
            </el-form>
        </div>

        <el-tabs v-model="activeTab" style="margin-top: 30px;">
            <el-tab-pane label="对公账户余额" name="PUBLICACCOUNTBALANCE">
                <el-table class="data-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="awardDetail.publicAccountBalance" :row-key="() => Math.random()">
                    <el-table-column prop="userId" label="用户ID"></el-table-column>
                    <el-table-column prop="coinType" label="挖矿币种"></el-table-column>
                    <el-table-column prop="coinAmount" label="币种数量"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="未发放奖励数量" name="AWARD">
                <el-table class="data-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="awardDetail.awardVOS" :row-key="() => Math.random()">
                    <el-table-column prop="count" label="用户数量"></el-table-column>
                    <el-table-column prop="miningCoin" label="奖励币种"></el-table-column>
                    <el-table-column prop="totalAward" label="总奖励额"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="用户挖矿余额" name="BALANCE">
                <el-table class="data-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="awardDetail.balanceVOS" :row-key="() => Math.random()">
                    <el-table-column prop="coinType" label="挖矿币种"></el-table-column>
                    <el-table-column prop="miningAmount" label="挖矿数量"></el-table-column>
                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button type="danger" @click="deleteAward(scope.row.coinType)">删除</el-button>
                            <el-button type="danger" @click="unLockUserMining(scope.row.coinType)">解锁</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="导入数据" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-table class="data-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="importData" :row-key="() => Math.random()">
                <el-table-column prop="coinType" label="挖矿币种(coinType)"></el-table-column>
                <el-table-column prop="miningCoin" label="奖励币种(miningCoin)"></el-table-column>
                <el-table-column prop="coinPrice" label="代币价格(coinPrice)"></el-table-column>
                <el-table-column prop="miningCoinPrice" label="所得币价格(miningCoinPrice)"></el-table-column>
                <el-table-column prop="todayRate" label="当日利率(todayRate)"></el-table-column>
            </el-table>


            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="calculateMiningAward">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import XLSX from 'xlsx';
    import '../store';
    import api from '../api';

    export default {
        name: 'AwardList',
        data() {
            return {
                accept: ['xlsx', 'xls', 'csv'],
                awardDetail: {}, //数据
                award: { //查询参数
                    coinType: "",
                    miningCoin: "",
                    todayRate: "",
                    coinPrice: "",
                    miningCoinPrice: ""
                },
                coinTypes: [],
                activeTab: "PUBLICACCOUNTBALANCE",
                dialogVisible: false,
                importData: [],
                loading: false
            }
        },
        computed: {
            acceptStr() {
                return this.accept.map(item => `.${item}`).join(', ');
            }
        },
        methods: {
            getUserMiningAward() {
                api.getUserMiningAward().then(({data}) => {
                    this.awardDetail = data;
                });
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            revenueCalculation() {
                if (this.award.todayRate == "") {
                    this.$message.info("请输入当日利率");
                    return;
                }
                if (this.award.coinPrice == "") {
                    this.$message.info("请输入代币价格");
                    return;
                }
                if (this.award.miningCoinPrice == "") {
                    this.$message.info("请输所得币价格");
                    return;
                }
                if (this.award.miningCoin == "") {
                    this.$message.info("请输入奖励币种");
                    return;
                }
                if (this.award.coinType == "") {
                    this.$message.info("请输入挖矿币种");
                    return;
                }
                api.adminCalculateMiningAward(this.award).then((rep) => {
                    this.$message.success(rep.msg);
                });
            },
            deleteAward(coinType) {
                api.deleteAward({coinType: coinType}).then((rep) => {
                    this.$message.success(rep.msg);
                    this.reflashData();
                });
            },
            unLockUserMining(coinType) {
                api.unLockUserMining({coinType: coinType}).then((rep) => {
                    this.$message.success(rep.msg);
                    this.reflashData();
                });
            },
            calculateMiningAward() {
                if (!this.importData || this.importData.length <= 0) {
                    this.$message.error("数据不能为空！");
                    return;
                }
                this.$confirm('确认导入这些数据吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    api.calculateMiningAward({awardDataDTO: JSON.stringify(this.importData)}).then((rep) => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$message.success(rep.msg);
                        this.reflashData();
                    });
                }).catch(() => {
                });
            },
            onFileChange(file) {
                if (!file) return;
                const {raw: originFile} = file;
                const {name, size} = originFile;
                const suffix = name.split('.').pop();
                if (!this.accept.includes(suffix)) {
                    this.$message.error(`只能上传${this.acceptStr}格式的文件`);
                    return;
                }
                this.readDataFromFile(originFile);
            },
            readDataFromFile(file) {
                const that = this;
                const reader = new FileReader();
                reader.onload = function (e) {
                    // pre-process data
                    let binary = '';
                    const bytes = new Uint8Array(e.target.result);
                    const length = bytes.byteLength;
                    for (let i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }

                    /* read workbook */
                    const wb = XLSX.read(binary, {
                        type: 'binary'
                    });

                    /* grab first sheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];

                    /* generate HTML */
                    that.importData = XLSX.utils.sheet_to_json(ws);
                    that.dialogVisible = true;
                };
                reader.readAsArrayBuffer(file);
            },
            incomeDistribution() { //已废弃
                api.adminAwardTransfer().then((rep) => {
                    this.$message.success(rep.msg);
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            reflashData() {
                this.getAllSupportCoin();
                this.getUserMiningAward();
            },
            clearData() {
                this.importData = [];
                this.loading = false;
            }
        },
        created() {
            // this.getAllSupportCoin();
            // this.getUserMiningAward();
        }
    };
</script>

<style lang="less" scoped>
    .rate-box {
    }
</style>
